import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";

const linkButtonClass = css({
    cursor: 'pointer',
    color: 'primary.500'
})

const LinkButton = createPandaComponent('LinkButton', 'button', [linkButtonClass]);

export default LinkButton;